import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import Moment from 'react-moment';

import { makeGetSortedActiveProjectTaskGroups } from '../selectors/task-groups';
import { makeGetSortedActiveProjectTasks } from '../selectors/tasks';

import { fetchTasks } from '../actions/tasks';

import { getTasksFetched, getTasksLoading } from '../services/store-service';

import Popout from './popout';
import FieldDefault from './field-default';

import IconClose from '../icons/icon-close';

class SelectTaskPopout extends PureComponent {
    static defaultProps = {
        excluded: []
    };

    state = {
        searchTerm: '',
        popoutVisible: false
    }

    handlePopoutOpenClick = () => {
        this.show();
    }

    handlePopoutCloseClick = () => {
        this.popoutCtrl.hide();
    }

    handlePopoutShow = () => {
        this.setState({
            popoutVisible: true
        });
    }

    handlePopoutHide = () => {
        this.setState({
            popoutVisible: false
        });
    }

    handleTaskUntie = () => {
        this.props.onUntie && this.props.onUntie();

        this.popoutCtrl.hide();
    }

    handleTaskSelect(task) {
        this.props.onSelect(task);

        this.popoutCtrl.hide();
    }

    handleSearchChange = searchTerm => {
        this.setState({ searchTerm });
    }

    show() {
        this.popoutCtrl.show();
        this.attemptFetch();
    }

    attemptFetch() {
        this.props.taskGroups.forEach(taskGroup => {
            if (!getTasksFetched('taskGroup', taskGroup.id) && !getTasksLoading('taskGroup', taskGroup.id)) {
                fetchTasks({
                    taskGroupId: taskGroup.id
                }, true);
            }
        });
    }

    setPopoutCtrl = ctrl => this.popoutCtrl = ctrl;

    get tasks() {
        const tasks = this.props.tasks.filter(task => (!task.milestone || task.milestone === this.props.milestone) && !this.props.excluded.includes(task.id));

        return this.state.searchTerm ? tasks.filter(task => (task.name || '').toLowerCase().indexOf(this.state.searchTerm.toLowerCase()) > -1) : tasks;
    }

    render() {
        // TODO: Add content loader
        const children = React.Children.map(this.props.children, child => {
            return React.cloneElement(child, {
                className: child.props.className + (this.state.popoutVisible ? ' selected disable-tooltip' : '')
            });
        });

        return (
            <React.Fragment>
                <div onClick={this.handlePopoutOpenClick}>
                    {children}
                </div>

                <Popout
                    className="no-arrow xxsmall"
                    provideController={this.setPopoutCtrl}
                    onShow={this.handlePopoutShow}
                    onHide={this.handlePopoutHide}
                    xAlign={this.props.xAlign}
                    defaultXPosition={this.props.defaultXPosition}
                    closeOnEveryClick={true}
                >
                    <div className="popout-head">
                        {this.props.title}

                        <button className="btn btn-icon btn-small popout-close" onClick={this.handlePopoutCloseClick}>
                            <IconClose />
                        </button>
                    </div>

                    <div className="popout-main">
                        <div className="resource-selector nice-scroll">
                            <FieldDefault
                                small={true}
                                placeholder="Search tasks…"
                                value={this.state.searchTerm}
                                autoFocus={true}
                                onChange={this.handleSearchChange}
                            />

                            {
                                this.tasks.length ?
                                    this.tasks.map(task => (
                                        <div className={'item' + (this.props.selected === task.id ? ' selected' : '')} key={task.id}>
                                            <div className="item-inner" onClick={this.handleTaskSelect.bind(this, task)}>
                                                <div className="item-body">
                                                    <h5>{task.name}</h5>

                                                    {
                                                        task.due_date ? (
                                                            <h6>
                                                                <Moment format="MMM. DD">{task.due_date}</Moment>
                                                            </h6>
                                                        ) : null
                                                    }
                                                </div>

                                                <div className="item-marker">
                                                    <i className="ion ion-checkmark" />
                                                </div>
                                            </div>
                                        </div>
                                    ))
                                :
                                <p className="no-resources">No Tasks available.</p>
                            }
                        </div>
                    </div>

                    {
                        this.props.selected ? (
                            <div className="popout-foot">
                                <span className="action" onClick={this.handleTaskUntie}>Remove Task</span>
                            </div>
                        ) : null
                    }
                </Popout>
            </React.Fragment>
        );
    }
}

const makeMapStateToProps = () => {
    const getSortedActiveProjectTaskGroups = makeGetSortedActiveProjectTaskGroups();
    const getSortedActiveProjectTasks = makeGetSortedActiveProjectTasks();

    return ({ taskGroups, tasks }, ownProps) => {
        return {
            taskGroups: getSortedActiveProjectTaskGroups(taskGroups.items, ownProps.projectId),
            tasks: getSortedActiveProjectTasks(tasks.items, ownProps.projectId)
        }
    }
}

export default connect(makeMapStateToProps)(SelectTaskPopout);
